export default __webpack_public_path__ + "static/20-781e42e3d970da15c49fb4055c58f585.png";